// @ts-ignore
// @ts-nocheck
import React, { useState, useEffect } from 'react';
import { AiOutlineClose } from 'react-icons/ai';

import { useMediaQuery } from 'react-responsive';
import UllyIMG from 'assets/images/ully.svg';

import {
  Container,
  Overlay,
  ModalContainer,
  ModalHeader,
  ModalTitleWrap,
  ModalHeaderTitle,
  ModalHeaderText,
  ModalCloseButton,
  Separator,
  Footer,
  FooterText,
  FooterHighLight,
  UllyImgContainer,
  ImgUlly,
} from './styles';

import { ModalCodeExampleProps } from './types';

const ModalCodeExample: React.FC<ModalCodeExampleProps> = ({
  isOpen,
  setShowModal,
  children,
}) => {
  const [showMobileMode, setShowMobileMode] = useState(true);

  const isMobile = useMediaQuery({ maxWidth: 959 });

  useEffect(() => {
    setShowMobileMode(isMobile);
  }, [isMobile]);

  return (
    <Container $isOpen={isOpen}>
      <Overlay $isOpen={isOpen} />
      <ModalContainer>
        <ModalHeader>
          <ModalTitleWrap>
            <ModalHeaderTitle>
              Onde posso encontrar meu código do cliente?
            </ModalHeaderTitle>
            <ModalHeaderText>
              Existem alguns modelos de Nota Fiscal verifique qual é a sua.
            </ModalHeaderText>
          </ModalTitleWrap>
          <ModalCloseButton onClick={() => setShowModal(false)}>
            <AiOutlineClose size={32} color="#0013F5" />
          </ModalCloseButton>
        </ModalHeader>
        <Separator />
        {children}
        <Footer>
          {!showMobileMode && (
            <>
              <FooterText>
                {`Ainda está com dúvidas? Fale com a `}
                <FooterHighLight>Ully!</FooterHighLight>
              </FooterText>
              <UllyImgContainer>
                <ImgUlly src={UllyIMG} />
              </UllyImgContainer>
            </>
          )}
        </Footer>
      </ModalContainer>
    </Container>
  );
};

export default ModalCodeExample;
